import React from 'react';

import { Container } from '@/components/ui';

export const GlobalActions: React.FC = () => {
  return (
    <Container className="bg-chariot-background-primary/60 border-chariot-stroke flex-1 rounded-md border-2 p-6">
      <div className="flex size-full flex-col gap-4">
        <h2 className="text-xl font-semibold">Global Actions</h2>
        <p className="text-chariot-text-secondary text-sm">
          Manage global actions across all customers and tenants
        </p>
      </div>
    </Container>
  );
};
